import React, {useEffect, useRef} from 'react';
import {getKashflowCustomer} from 'api/modules.api';
import XeroPaymentSettings from './form/XeroPaymentSettings';
import {Col, Row,} from "reactstrap";

export default function XeroDetail({ deal }) {

    useEffect(() => {
        if (deal.customer_id) {
            fetchKashflowCustomer(deal.customer_id)
        }
    }, [deal.customer_id]);



    const fetchKashflowCustomer = (customerId) => {
        getKashflowCustomer(customerId).then(() => {
        })
    }

    return (
        <Row>
            <Col>
                <XeroPaymentSettings deal={deal} />
            </Col>
        </Row>)
}